export default {"src":"/_next/static/media/x-close.ab48beb6.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};